module.exports = __webpack_public_path__ + "static/media/home_banner.7f1b1280.jpg";